import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function AdminRoute() {
  const { user, checked } = useAuth();
  if (!checked) {
    return <div className="min-h-screen bg-[#030305] flex items-center justify-center text-[#00F0FF] font-mono2 text-sm">Loading…</div>;
  }
  return user ? <AdminDashboard /> : <AdminLogin />;
}

function App() {
  return (
    <div className="App">
      <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
        <AuthProvider>
          <CartProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/admin" element={<AdminRoute />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </BrowserRouter>
            <Toaster theme="dark" position="top-center" toastOptions={{ style: { background: "#0A0A0C", border: "1px solid rgba(0,240,255,0.25)", color: "#fff" } }} />
          </CartProvider>
        </AuthProvider>
      </ReactLenis>
    </div>
  );
}

export default App;
